module.exports = __webpack_public_path__ + "static/media/teams-planning-and-discussion-of-new-ideas-by-men.3ce7612c.png";